import React, { FC } from 'react'
import { Button } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";


import { CategoryModel } from '../../models/category-model';

interface CategoryFilterButtonProps {
    category: CategoryModel;
    onCheckFilter: (id: string, checked: boolean) => void;
    checked: boolean;
}

const useStyles =  makeStyles({
    filterButton: (props: any) => ({
        backgroundColor: props.checked ? '#D32F2F' : "white",
        color: props.checked ? "white" : "gray",
        borderRadius: "24px",
        height: '32px',
        margin: '5px 5px',
        textAlign: 'center',
        whiteSpace: 'nowrap'
    })
});

const CategoryFilterButton: FC<CategoryFilterButtonProps> = (props: CategoryFilterButtonProps) => {

    const { category, onCheckFilter, checked }= props;
    const classes = useStyles(props);

    const checkFilter = () => {
        onCheckFilter(category._id, !checked);
    }

    return (
        <Button 
            className={classes.filterButton}
            onClick={checkFilter} key={category._id} 
            variant="contained"
        >
            {category.name}
        </Button>
    )
}

export default CategoryFilterButton;
